/* eslint-disable */
<template>

  <template v-if="agid">
    <div class="ic1-row login-infocert">
      <div class="ic1-col-12 ic1-centered">
        <div class="ic1-card ic1-card-main ic1-card-md">
          <div class="ic1-card-title">
            <div class="ic1-row">
              <div class="ic1-col-12 ic1-no-bottom-padding">
                <img aria-hidden="true" src="../assets/InfocertID.svg" style="width: 160px;" alt="infocert-id" />
              </div>
            </div>
          </div>

          <div class="ic1-card-subtitle ic1-row">
            <div class="ic1-col-12 ic1-no-up-padding">
              <hr />
              <span class="ic1-text-subtitle-2">{{ t("SPID.access_request") }} {{ spidLevel }}
                {{ t("SPID.lbl_from") }}</span>
              <span class="ic1-text-heading-4">{{ spName }}</span>
              <div class="ic1-col-12 ic1-card-error" v-if="errored">
                <em class="ic1-icon-status-error"></em>
                <div class="ic1-card-error-content">
                  <span class="ic1-text-label-3">{{ errorMsg }}</span>
                  <span class="ic1-text-body-2" v-html="errorMsgDescription"></span>
                </div>
              </div>
            </div>
          </div>

          <!--  Mobile quickaccess -->
         <!-- <div class="ic1-col-12" style="padding: 0 !important;" v-if="$isMobile()">
            <div class="ic1-row">
              <div class="ic1-col-md-8">
                <div class="ic1-card ic1-card-outlined ic1-card-icon-left ic1-p-20"
                  style="background-color: #f5f6f9;display: flex; flex-wrap: nowrap;justify-content: space-evenly;">
                  <div class="ic1-card-icon" style="align-items: center; align-self: center;">
                    <img src="https://uikit.infocert.it/dist/v8/brands/my-infocert/Style=Default,%20Minimize=On.svg"
                      alt="Infocert logo" style="height: 100%; width: 100%;min-width: 2rem;">
                  </div>
                  <div class="ic1-card-content" style="display: block;">
                    <div class="ic1-card-header" style="margin-bottom: 0 !important;">
                      <div class="ic1-col" style="padding: 0 !important;">
                        <div class="ic1-card-title"
                          style="margin-bottom: 0 !important; font-weight: 600 !important; font-size: 1rem !important;">
                          {{
                            t('SPID.label_check_myinfocert') }}</div>
                        <button class="ic1-btn ic1-btn-md ic1-btn-text" @click="quickAccess">
                          {{ t('SPID.quick_access') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  -->


          <!-- <div class="ic1-row">
            <div class="ic1-col-12">
              <button :disabled="disabled" class="ic1-app-card ic1-btn-block-md" v-if="false">
                <div class="ic1-card-img">
                  <img src="img/my-infocert.png" alt="my-infocert" />
                </div>
                <div class="ic1-app-card-content" @click="gotoApp">
                  <span class="ic1-text-label-3">{{
                    t("SPID.MY_INFOCERT_APP")
                  }}</span>
                  <span class="ic1-btn ic1-btn-text">
                    {{ t("SPID.ENTER") }}
                  </span>
                </div>
              </button>
            </div>
          </div> -->

          <div class="ic1-card-content">
            <!-- SPID LOGIN FORM * begin * -->
            <div class="ic1-row">
              <div :class="classObject">
                <form name="spid-login" id="spid-login" @submit.prevent="handleLogin">
                  <input id="transactionId" name="transactionId" type="hidden" :value="transactionId" />
                  <input id="authCode" name="authCode" type="hidden" :value="authCode" />

                  <div class="ic1-row">
                    <div class="ic1-col-md-12 ic1-no-side-padding">
                      <div class="ic1-form-group">
                        <label class="ic1-text-label-1" for="nome_utente">{{
                          t("SPID.user_name")
                        }}</label>
                        <input id="nome_utente" autocomplete="username" name="nome_utente" :class="userClasses"
                          v-model="nome_utente" :placeholder="t('SPID.label_placeholder')" @focus="handleOnFocus" />
                        <em class="ic1-text-small-2" style="color:#DA100B" v-if="errored">{{ t("SPID.EMAIL_NOT_VALID")
                          }}</em>
                      </div>
                      <span class="clear"></span>
                    </div>
                  </div>
                  <div class="ic1-row">
                    <div class="ic1-col-md-12 ic1-no-side-padding">
                      <div class="ic1-form-group">

                        <passwordField ref="passwordField" :label="t('SPID.password')"
                          :icon_alt="t('SPID.show_password')" v-model="password" @on-focus="handleOnFocus"
                          :input-classes="inputClasses"></passwordField>

                        <em class="ic1-text-small-2" style="color:#DA100B" v-if="errored">{{
                          t("SPID.PASSWORD_NOT_VALID") }}</em>
                      </div>
                    </div>
                  </div>
                  <div class="ic1-row">
                    <div class="ic1-col-12 ic1-no-side-padding">
                      <span class="ic1-text-label-2">
                        {{ t("SPID.label_retries") }} {{ retries }}
                      </span>
                    </div>
                  </div>
                  <div class="ic1-row">
                    <div class="ic1-col-12 ic1-no-side-padding">
                      <a style="cursor:pointer;" :disabled="disabled" href="#" @click="gotoNoUsername"
                        class="ic1-btn ic1-btn-md ic1-btn-text forgotten-link">
                        {{ t("SPID.forgotten_password") }}
                      </a>
                    </div>
                  </div>
                  <div class="ic1-row">
                    <div class="ic1-row-btn-container ic1-col-md-12 ic1-no-side-padding">
                      <button :disabled="disabled" @click="handleCancel" type="button"
                        class="ic1-btn ic1-btn-md ic1-btn-secondary ic1-btn-block-sm btn-order-cancel">
                        {{ t("SPID.cancel_btn") }}
                      </button>
                      <button :disabled="disabled" ref="btn_submit" type="submit"
                        class="ic1-btn ic1-btn-md ic1-btn-agid ic1-btn-block-sm btn-order-ok">
                        <img aria-hidden="true" src="../assets/user-icon.png" class="ic1-icon-agid" alt="user-icon" />
                        <em class="ic1-separator"></em>
                        {{ t("SPID.ok_btn") }}
                      </button>
                    </div>
                  </div>
                  <div class="ic1-row ">
                    <div class="ic1-col-12 ic1-centered">
                      {{ t("SPID.NO_SPID") }}&nbsp;
                      <button :disabled="disabled" ref="btn_submit" type="button" @click="gotoSignIn"
                        class="ic1-btn ic1-btn-md ic1-btn-text ic1-btn-text-noflex">
                        {{ t("SPID.SIGN_IN") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="ic1-col-12 ic1-col-md-5 ic1-item-centered" v-show="!$isMobile()">
                <!--   <qr-code @created="onCreated" @mounted="onMounted" @logged="onLogged" @error="onError"
                  :refresh="refresh_qrcode" :locale="language" :authurl="auth_url" :wsurl="ws_url" :samlurl="saml_url">
                </qr-code> -->
                <div>
                  <div class="ic1-text-center ic1-mb-16">
                    <h4 class="ic1-text-heading-4-bold ic1-mb-8">{{ t('SPID.quick_access_title') }}</h4>
                    <p v-if="!qrCodeError" class="ic1-text-body-2 ic1-mb-24">
                      <span>{{ this.t('SPID.qr_code') }}</span>
                    </p>
                  </div>
                  <div class="ic1-centered ic1-mb-16">
                    <div v-if="showQrCodeLoader && !qrCodeError" class="ic1-spinner-wrapper ic1-centered" role="alert"
                      aria-busy="true">
                      <div class="ic1-spinner ic1-spinner-xl"></div>
                    </div>
                    <img id="qrcode" v-show="!showQrCodeLoader && !qrCodeError && qrCode" width="180" height="180" :src="qrCode"
                      alt="QR Code" />
                    <span v-if="qrCodeError && !showQrCodeLoader" class="ic1-text-body-2 ic1-text-center">{{ qrCodeError }}</span>
                  </div>
                  <div v-if="!qrCodeError && !showQrCodeLoader" class="ic1-text-center ic1-mt-24">
                    <span class="ic1-text-body-2" v-html="qrCodeTimerLabel"></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-else>
    <form name="spid-login" id="spid-login" @submit.prevent="handleLogin" class="grid">
      <div class="width-one-whole">
        <fieldset>
          <div>
            <label for="nome_utente" class="float-left label-bold">{{ t('SPID.user_name') }}</label>
            <input id="transactionId" name="transactionId" type="hidden" :value="transactionId" />
            <input id="authCode" name="authCode" type="hidden" :value="authCode" />

            <span class="forgot-link">
              <a :href="no_username_url" target="_blank">
                {{ t("SPID.forgotten_user") }}
                <img class="open-link" src="img/open-link.svg"
                  onerror="this.src='img/open-link.png'; this.onerror=null;" alt="{{t('SPID.new_page')}}" />
              </a>
            </span>
            <input id="nome_utente" name="nome_utente" v-model="nome_utente" type="text" required
              class="input-error" /><span class="clear"></span>
          </div>
          <div>
            <label for="password" class="float-left label-bold">{{ t('SPID.password') }}</label>
            <span class="forgot-link">
              <a :href=no_password_url target="_blank">
                {{ t('SPID.forgotten_password') }}
                <img class="open-link" src="img/open-link.svg"
                  onerror="this.src='img/open-link.png'; this.onerror=null;" alt="{{t('SPID.new_page')}}" />
              </a>
            </span>
            <input id="password" name="password" v-model="password" required :type="type" class="showpassword" /><span
              class="clear"></span>
          </div>
          <div class="push-right spacer-top-2">
            <input id="showHide" type="checkbox" class="showpasswordcheckbox" @click="showPassword" />
            <label class="showHideLabel" for="showHide" role="button">{{ t('SPID.show_password') }}</label>
          </div>
          <div class="control-group">
          </div>
        </fieldset>
        <button :disabled="disabled" type="submit"
          class="italia-it-button italia-it-button-size-m button-spid spacer-top-1">
          <span class="italia-it-button-icon"><img aria-hidden="true" src="img/spid-ico-circle-bb.svg"
              onerror="this.src='img/spid-ico-circle-bb.png'; this.onerror=null;" alt="" /></span>
          <span class="italia-it-button-text">{{ t('SPID.ok_btn') }}</span>
        </button>
      </div>
    </form>
    <!-- SPID LOGIN FORM * end * -->
    <div class="grid spacer-top-1">
      <div class="width-one-half push-left spid-link">
        <a :href="sign_in_url" target="_blank">
          {{ t("SPID.NO_SPID") }}
          <img class="open-link" src="img/open-link.svg" onerror="this.src='img/open-link.png'; this.onerror=null;"
            alt="Si apre una nuova pagina" />
        </a>
      </div>
      <div class="width-one-half push-right spid-link">
        <a href="javascript:void(0)" @click="handleCancel">
          {{ t("SPID.cancel_btn") }}
          <img class="open-link" src="img/open-link.svg" onerror="this.src='img/open-link.png'; this.onerror=null;"
            alt="Si apre una nuova pagina" />
        </a>
      </div>
    </div>
  </template>

  <component :is="agid ? 'login-infocert' : 'login-tim'" />

</template>

<script>
import AuthService from "../services/auth.service.js";

import store from "@/store";
import { useI18n } from "vue-i18n";
import { ref } from "vue";

import PasswordField from "@/components/ui/passwordField/PasswordField";
import { environment } from "@/config";
import { createCookie } from "@/utils/useCookie";

export default {
  props: {
    value: Number
  },
  emits: ["logged", "error"],
  setup() {
    // context has attrs, slots, and emit()
    console.log("setup()");
    const { t, locale } = useI18n();
    const count = ref(0);
    return { count, t, locale };
  },
  components: {
    passwordField: PasswordField
  },
  created() {
    console.log("created()");
    console.log("isMobile: " + this.$isMobile());

    this.transactionId = this.getParam("transactionId");
    this.authCode = this.getParam("authCode");
    this.state = this.getParam("state");
    this.elapsed = this.getParam("elapsed");

    console.log("this.transactionId: " + this.transactionId);
    console.log("this.authCode: " + this.authCode);
    console.log("this.state: " + this.state);
    console.log("this.elapsed: " + this.elapsed);

    this.startPasswordlessChallenge();

    this.$nextTick(() => {
      const qrImage = document.querySelector("#qrcode");
      if (qrImage) {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === "attributes" && mutation.attributeName === "src") {
              const base64QrCode = qrImage.src;
              this.decodeQrCode(base64QrCode);
            }
          }
        });
        observer.observe(qrImage, { attributes: true });
        this.qrObserver = observer;
      }
    });
  },

  data() {
    return {
      showQrCodeLoader: false,
      passwordLessSessionId: null,
      qrCode: null,
      qrCodeError: null,
      qrCodeTimer: null,
      qrCodeSecondsLeft: 0,
      qrCodeTimerLabel: "",
      decodedQrCode: "",
      nome_utente: null,
      password: null,
      info: null,
      type: "password",
      valueInternal: this.value,
      loggedIn: false,
      error: null,
      errored: false,
      errorCode: null,
      errorMsg: null,
      errorMsgDescription: null,
      retries: this.$env.VUE_APP_RETRIES,
      query: null,
      transactionId: null,
      authCode: null,
      no_username_url: this.$env.VUE_APP_NO_USERNAME_URL,
      no_password_url: this.$env.VUE_APP_NO_PASSWORD_URL,
      sign_in_url: this.$env.VUE_APP_SIGN_IN_URL,
      cancel_url: this.$env.VUE_APP_CANCEL_URL,
      APP_SAML_URL: this.$env.VUE_APP_SAML_URL,
      spName: null,
      spidLevel: null,
      inputClasses: "ic1-input showpassword",
      userClasses: "ic1-input",
      state: null,
      elapsed: null,
      language: this.locale,
      auth_url: this.$env.VUE_APP_QR_CODE_AUTHORIZATION_URL,
      ws_url: this.$env.VUE_APP_WS_URL,
      saml_url: this.$env.VUE_APP_SAML_URL,
      refresh_qrcode: this.$env.VUE_APP_REFRESH_QRCODE,
      disabled: false,
      reset_password_url: this.$env.VUE_APP_RESET_PASSWORD_URL,
    };
  },

  computed: {
    classObject() {
      if (!this.$isMobile()) {
        return "ic1-col-12 ic1-col-md-7 ic1-col-border-right";
      } else {
        return "ic1-col-md-12 ic1-col-12";
      }
    },
    currentSpName() {
      return store.getters.getSpName;
    },
    currentSpidLevel() {
      return store.getters.getSpidLevel;
    },
    agid() {
      return process.env.VUE_APP_SUB_PATH !== "tim";
    }
  },
  watch: {
    currentSpName(newSpName) {
      this.spName = newSpName.spName;
    },
    currentSpidLevel(newSpidLevel) {
      this.spidLevel = newSpidLevel.spidLevel;
    }
  },

  methods: {
    startPasswordlessChallenge() {
      this.showQrCodeLoader = true;
      this.passwordLessSessionId = this.transactionId;
      AuthService.startChallenge(this.passwordLessSessionId)
        .then((res) => {
          this.showQrCodeLoader = false;
          if (res && res.data && res.data.challenge) {
            this.qrCode = "data:image/png;base64," + res.data.challenge;
            this.startQrCodeTimer();
          }
        })
        .catch((error) => {
          this.qrCodeError = this.$t('SPID.qrcode_error', {}, { locale: this.locale });
          this.showQrCodeLoader = false;
        });
    },
    startQrCodeTimer() {
      if (this.qrCodeTimer) {
        clearInterval(this.qrCodeTimer);
      }
      this.qrCodeSecondsLeft = 30;
      this.qrCodeTimer = setInterval(() => {
        if (this.qrCodeSecondsLeft > 0) {
          this.qrCodeSecondsLeft -= 3;
          this.formatQrCodeTimerLabel();
          this.verifyPasswordlessChallenge();
        } else {
          this.updatePasswordlessChallenge();
          clearInterval(this.qrCodeTimer);
        }
      }, 3000);
    },
    formatQrCodeTimerLabel() {
      this.qrCodeTimerLabel = this.t('SPID.code_valid_for', {}, { locale: this.locale }) + '<b>' + this.qrCodeSecondsLeft.toString() + '</b>' + this.t('SPID.seconds', {}, { locale: this.locale });
    },
    updatePasswordlessChallenge() {
      if (!this.passwordLessSessionId) return;
      this.showQrCodeLoader = true;
      AuthService.updateChallenge(this.passwordLessSessionId, {})
        .then((res) => {
          this.showQrCodeLoader = false;
          if (res && res.data && res.data.challenge) {
            this.qrCode = "data:image/png;base64," + res.data.challenge;
            this.startQrCodeTimer();
          }
        })
        .catch((error) => {
          this.qrCodeError = this.$t('SPID.qrcode_error', {}, { locale: this.locale });
          this.showQrCodeLoader = false;
        });
    },
    verifyPasswordlessChallenge() {
      if (!this.passwordLessSessionId) return;
      AuthService.verifyChallenge(this.passwordLessSessionId)
        .then((res) => {
          if (res && res.data && res.data.status === 'VERIFIED' && res.data.userId) {
            this.qrCodeTimer && clearInterval(this.qrCodeTimer);
            this.onSuccessPasswordless();
          }
        })
        .catch((error) => {
          console.error('Error verifying passwordless challenge:', error);
        });
    },
    onSuccessPasswordless() {
      this.showQrCodeLoader = true;
      AuthService.qrLogin({ sessionId: this.transactionId, authCode: this.authCode })
        .then((data) => {
          if (data) {
              this.showQrCodeLoader = false;
              this.handleAuthorizedPasswordless(data);
          }
        /*   console.log('success: login.component.onSuccessPasswordless()', data);
          const legacy = this.getCookie('legacy') === 'true';
          if (legacy) {
            AuthService.authentication(this.transactionId, legacy)
              .then((data) => {
                this.showQrCodeLoader = false;
                this.handleAuthorizedPasswordless(data);
              })
              .catch((err) => {
                console.error('error: login.component.handleAuthentication()', err);
                this.showQrCodeLoader = false;
                if (err && err.url) {
                  window.location.href = err?.url;
                }
              });
          } else {
            AuthService.authentication(this.flowId, legacy);
          } */
        })
        .catch((err) => {
          console.error('error: login.component.qrLogin()', err);
          this.showQrCodeLoader = false;
          this.qrCodeError = this.$t('SPID.qrcode_login_error', {}, { locale: this.locale });
        });
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    },

    handleAuthorizedPasswordless(response) {
      console.log('User authorized successfully');
      const location = response.headers["location"];
      console.log("AuthService.login(user) response:" + JSON.stringify(response));
      console.log("AuthService.login(user) response Location header:" + location);
      createCookie("username", this.nome_utente || response.data.username);
      const state = this.$route.query.state;
      window.location.replace(
        location +
        "?state=" +
        state +
        "&sessionId=" +
        this.transactionId +
        "&authCode=" +
        this.authCode
      );
    },
    quickAccess() {
      let baseUrl = 'myinfocert://action/passwordless?base64=' + this.decodedQrCode;
      window.location.href = baseUrl;
    }, 
    onCreated() {
      console.log("spid-passwordless: created");
    },
    onMounted() {
      console.log("spid-passwordless: mounted");
    },
    onLogged(message) {
      console.log("spid-passwordless: onLogged message: " + message);
    },
    onError(message) {
      console.log("spid-passwordless: onError message: " + message);
    },
    handleOnFocus() {
      console.log("handleOnFocus");

      if (this.errored) {
        this.inputClasses = "ic1-input showpassword";
        this.userClasses = "ic1-input";
        this.errored = false;
      }
    },
    handleErrorInput() {
      this.inputClasses = "ic1-input showpassword error";
      this.userClasses = "ic1-input error";
    },
    handleClearInput() {
      this.codice = "";
      this.password = "";
      this.$nextTick(() => this.$refs.btn_submit.focus());
    },
    /* gotoApp() {
      const url = this.$env.VUE_APP_INTENT_URL;

      window.location.replace(url);
    }, */
    gotoSignIn() {
      window.open(this.sign_in_url);
    },
    gotoNoUsername() {
      window.open(this.no_username_url);
    },
    getParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get(name);
      return myParam;
    },
    showPassword() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },

    setErrorCode(errorMsg, errorMsgDescription, args) {
      store.dispatch("setErrorCode", {
        errorCode: errorMsg,
        errorArgs: errorMsgDescription
      });

      // Aggiungi l'URL di reset password agli argomenti se non è già presente
      const translationArgs = {
        ...args,
        reset_password_url: this.reset_password_url
      };

      this.errorMsg = this.t(errorMsg, translationArgs, { locale: this.locale });  
      this.errorMsgDescription = this.t(errorMsgDescription, translationArgs, {
        locale: this.locale 
      });

      this.nome_utente = "";
      this.password = "";
      this.errored = true;
      if (this.retries > 0) {
        this.retries--;
      }
    },

    handleLogin() {
      console.log("handleLogin: ", this.nome_utente);
      store.dispatch('setRedirect', false);
      store.dispatch('setErrorType', 'danger');

      if (!this.password) {
        this.password = this.$refs.passwordField.getValue();
        console.log("handleLogin updated pwd");
      }
      if (!this.nome_utente || !this.password) {
        this.handleErrorInput();
        let errorMessage = "SPID.INVALID_EMPTY";
        this.errorMsg = this.t(errorMessage, {}, { locale: this.locale });
        this.errorMsgDescription = "";
        this.errored = true;
      } else {
        this.errored = false;

        this.loading = true;
        let user = {
          username: this.nome_utente,
          password: this.password,
          transactionId: this.transactionId,
          authCode: this.authCode,
          elapsed: this.elapsed
        };

        this.disabled = true;

        AuthService.login(user)
          .then(response => {
            const location = response.headers["location"];
            console.log(
              "AuthService.login(user) response:" + JSON.stringify(response)
            );
            console.log(
              "AuthService.login(user) response Location header:" + location
            );

            createCookie("username", user.username);
            const state = this.$route.query.state;
            window.location.replace(
              location +
              "?state=" +
              state +
              "&sessionId=" +
              this.transactionId +
              "&authCode=" +
              this.authCode
            );
          })
          .catch(error => {
            this.disabled = false;
            /**
               50x internal server error
               400 bad request
               403 forbidden
               409 conflict
               410 password expired
               xxx
               */
            const expr = error.response.status;
            console.log(
              "AuthService.login(user) received status code: " + expr
            );
            let errorMessage = null;
            let errorMessageDes = null;
            let errorMessageArgs = {};
            switch (expr) {
              case 500:
                console.log("500");
                console.log(error.response.headers);

                errorMessage = "SPID.INVALID";
                errorMessageDes = "SPID.INVALID_DES";

                store.dispatch("setRedirect", JSON.parse(this.$env.VUE_APP_REDIRECT.toLowerCase()));
                store.dispatch("setErrorType", 'warning');
                this.$router.push({ name: "errorPage" });

                break;
              case 502:
                window.location.replace(
                  this.APP_SAML_URL + "/fault?errorCode=2&source=b"
                );
                break;
              case 400:
                // eslint-disable-next-line no-case-declarations
                const locationHeader = error.response.headers["location"];
                console.log(
                  "attempts terminated response Location:" + locationHeader
                );
                sessionStorage && sessionStorage.clear();
                window.location.replace(locationHeader);
                break;
              case 403:
                errorMessage = "SPID.INVALID";
                errorMessageDes = "SPID.INVALID_DES";
                break;
              case 409:
                switch (error.response.data.type) {
                  case "AGE":
                    errorMessage = this.agid ? "SPID.INVALID_AGE" : "SPID.INVALID_AGE_TIM";
                    errorMessageDes = "SPID.INVALID_AGE_DES";
                    break;
                  case "NATIONALITY" || "LIMITED":
                    errorMessage = this.agid ? "SPID.INVALID_NATIONALITY" : "SPID.INVALID_NATIONALITY_TIM";
                    errorMessageDes = "SPID.INVALID_NATIONALITY_DES";
                    break;
                  default:
                    errorMessage = "SPID.INVALID";
                    errorMessageDes = "SPID.INVALID_DES";
                }
                errorMessageArgs = error.response.data;
                break;
              case 410:
                // password expired
                if (error.response.data === "PWD_EXPIRED") {
                  errorMessage = "SPID.TITLE_PASSWORD_EXPIRED";
                  errorMessageDes = "SPID.MESSAGE_PASSWORD_EXPIRED_EXTENDED";
                } else if (error.response.data === "PWD_LOCKED") {
                  // password locked
                  errorMessage = "SPID.TITLE_PASSWORD_LOCKED";
                  errorMessageDes = "SPID.MESSAGE_PASSWORD_LOCKED_EXTENDED";
                } else if (error.response.data === "SPID_SUSPENDED") {
                  // spid suspended
                  errorMessage = "SPID.TITLE_SPID_SUSPENDED";
                  errorMessageDes = "SPID.MESSAGE_SPID_SUSPENDED_EXTENDED";
                }

                break;
              default:
                window.location.replace(
                  this.APP_SAML_URL + "/fault?errorCode=3&source=b"
                );
                break;
            }
            this.handleErrorInput();
            this.setErrorCode(errorMessage, errorMessageDes, errorMessageArgs);
          })
          .finally(() => (this.loading = false));
      }
    },
    handleCancel() {
      this.disabled = true;

      AuthService.abort()
        .then(response => {
          const location = response.headers["location"];
          console.log(
            "AuthService.abort() response Location header:" + location
          );
          sessionStorage && sessionStorage.clear();
          window.location.replace(location);
        })
        .catch(error => {
          this.disabled = false;
          const expr = error.response.status;
          console.log("AuthService.abort() received status code: " + expr);

          sessionStorage && sessionStorage.clear();
          switch (expr) {
            case 502:
              {
                window.location.replace(
                  this.APP_SAML_URL + "/fault?errorCode=2&source=b"
                );
              }
              break;
            case 400:
              {
                const location = error.response.headers["location"];
                console.log("user cancel action Location:" + location);
                window.location.replace(location);
              }
              break;
            default:
              window.location.replace(
                this.APP_SAML_URL + "/fault?errorCode=3&source=b"
              );
          }
        })
        .finally(() => (this.loading = false));
    },
    getRoutePath(transactionId, response, idToken) {
      const stepName = response.data.step;
      console.log("getRoutePath() step:" + stepName);
      this.setCookie("Authorization", idToken, 2);
      window.location.href =
        response.data.data.redirectUri + "?transactionId=" + transactionId;
    },

    async decodeQrCode(base64QrCode) {
      try {
        const response = await fetch(base64QrCode);
        const blob = await response.blob();
        const qrCodeText = await this.readQrFromBlob(blob);
        this.decodedQrCode = qrCodeText;
      } catch (error) {
        console.error("Errore durante la decodifica del QR Code:", error);
      }
    },

    async readQrFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async () => {
          const img = new Image();
          img.src = reader.result;
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            import("jsqr").then((jsQR) => {
              const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              const qrCode = jsQR.default(imageData.data, canvas.width, canvas.height);
              if (qrCode) {
                resolve(qrCode.data);
              } else {
                reject("QR Code non trovato nell'immagine.");
              }
            });
          };
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
      });
    }
  }
};
</script>

<style scoped>
hr {
  border: 0.1px solid #c2d1d9;
  margin-top: 20px;
  margin-bottom: 20px;
}

.ic1-item-centered {
  display: flex;
  justify-content: center;
}

.ic1-card-main {
  height: 100%;
}

.ic1-col-border-right {
  border-right: 0.5px solid #c2d1d9;
}

.ic1-btn-text-noflex {
  display: inline;
}

.ic1-row-btn-container {
  column-gap: 24px;
  row-gap: 12px;
}

.ic1-card-error {
  /* Auto Layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0.625rem 1.75rem;
  position: static;
  width: fit-content;
  height: fit-content;
  left: 0px;
  top: 0px;

  /* danger-alternative */

  background: #fbe7e7;
  /* danger */

  border: 1px solid #da100b;
  box-sizing: border-box;
  border-radius: 5px;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 10px 0px;
}

.ic1-card.ic1-card-md {
  max-width: 808px !important;
}

.ic1-no-side-padding {
  padding-left: 0px !important;
}

.forgotten-link {
  justify-content: start;
}

.ic1-btn.ic1-btn-md.ic1-btn-agid.ic1-btn-block-sm.btn-order-ok:focus {
  outline: 2px solid black !important;
  outline-offset: 2px !important;
}

.ic1-btn.ic1-btn-md.ic1-btn-secondary.ic1-btn-block-sm.btn-order-cancel:focus {
  outline: 2px solid black !important;
  outline-offset: 2px !important;
}

.ic1-btn.ic1-btn-md.ic1-btn-text.forgotten-link:focus {
  outline: 2px solid black !important;
  outline-offset: 2px !important;
}

@media screen and (max-width: 768px) {
  .ic1-col-border-right {
    border-right: 0px;
  }
}

@media screen and (min-width: 400px) and (max-width: 500px) {
  .ic1-btn-block-sm {
    width: 80%;
  }

  .ic1-row-btn-container {
    align-items: center;
  }
}

@media screen and (max-width: 399px) {
  .ic1-btn-block-sm {
    width: 100%;
  }

  .ic1-row-btn-container {
    flex-direction: column;
  }
}

@media screen and (min-width: 501px) {
  .ic1-row-btn-container button:last-child {
    margin-right: auto;
    margin-left: 0px;
  }
}

@media screen and (max-width: 500px) {
  .ic1-no-side-padding {
    padding-right: 0px !important;
  }

  .btn-order-cancel {
    order: 2;
  }

  .ic1-card-error {
    width: 100%;
  }

  .btn-order-ok {
    order: 1;
  }

  .ic1-row-btn-container {
    flex-direction: column;
  }
}

.ic1-row-btn-container {
  display: flex;
}

.ic1-app-card .ic1-card-img img {
  height: 76px !important;
}

.ic1-app-card {
  display: flex;
  background-color: #f4f6f9;
  border: none;
  gap: 24px;
  align-items: center;
  border-radius: 0.3125rem;
}

.ic1-app-card-content {
  display: flex;
  flex-flow: column;
  gap: 8px;
  text-align: left;
  align-items: flex-start;
}

.ic1-btn-block-md {
  width: 100%;
}

.control-group {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
  text-align: left;
  display: inline-block;
}
</style>
